import { render, staticRenderFns } from "./WorkflowDisplay.vue?vue&type=template&id=59c5933e&scoped=true&"
import script from "./WorkflowDisplay.vue?vue&type=script&lang=js&"
export * from "./WorkflowDisplay.vue?vue&type=script&lang=js&"
import style0 from "./WorkflowDisplay.vue?vue&type=style&index=0&id=59c5933e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c5933e",
  null
  
)

export default component.exports